import axios from 'axios'
import Message from '@/utils/globalFeedback'
import { attachRequestSession, authenticationError } from '@/utils/authFailure'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 50000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(attachRequestSession, error => {
  // Do something with request error
  console.log(error) // for debug
  return Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response
    }
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        return Promise.reject(authenticationError(response.config, res.message))
      }
      if (!response.config.silentError) {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }

      return Promise.reject(response.config.preserveErrorMessage
        ? Object.assign(new Error(res.message || '请求失败'), { code: res.code })
        : 'error')
    } else {
      return response.data
    }
  },
  error => {
    if (error.response && error.response.status === 401) {
      return Promise.reject(authenticationError(error.config))
    }
    console.log('err' + error)// for debug
    if (!error.config || !error.config.silentError) {
      Message({
        message: error.message,
        type: 'error',
        duration: 3 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js